import { render, staticRenderFns } from "./ClientsAccessList.vue?vue&type=template&id=24c07385&scoped=true"
import script from "./ClientsAccessList.vue?vue&type=script&lang=js"
export * from "./ClientsAccessList.vue?vue&type=script&lang=js"
import style0 from "./ClientsAccessList.vue?vue&type=style&index=0&id=24c07385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c07385",
  null
  
)

export default component.exports